import { render, staticRenderFns } from "./PayResult.vue?vue&type=template&id=10d2ce8b&scoped=true&"
import script from "./PayResult.vue?vue&type=script&lang=js&"
export * from "./PayResult.vue?vue&type=script&lang=js&"
import style0 from "./PayResult.vue?vue&type=style&index=0&id=10d2ce8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d2ce8b",
  null
  
)

export default component.exports